const buildAuthHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
});

const buildAuthJsonHeaders = (token) => ({
  "Content-Type": "application/json",
  ...buildAuthHeaders(token),
});

export const createDashboardApi = (apiBaseUrl, getToken) => {
  const request = (path, options = {}) => {
    const {
      method = "GET",
      body,
      auth = true,
      json = false,
      headers = {},
    } = options;

    const token = getToken?.();
    const mergedHeaders = {
      ...(auth ? buildAuthHeaders(token) : {}),
      ...(json ? { "Content-Type": "application/json" } : {}),
      ...headers,
    };

    return fetch(`${apiBaseUrl}${path}`, {
      method,
      headers: mergedHeaders,
      body,
    });
  };

  return {
    buildAuthHeaders: () => buildAuthHeaders(getToken?.()),
    buildAuthJsonHeaders: () => buildAuthJsonHeaders(getToken?.()),

    getCurrentUser: () => request("/auth/me"),
    getUserProperties: () => request("/properties/my/all"),
    getDeletedUserProperties: () => request("/properties/my/deleted"),
    getPropertyStats: () => request("/properties/my/stats"),
    getDeveloperProfile: () => request("/developers/me/profile"),
    getDevelopments: () => request("/developments/my/all"),
    getDeletedDevelopments: () => request("/developments/my/deleted"),
    getAppointments: () => request("/appointments/my"),
    getInquiries: () => request("/contact"),
    getMyRequests: () => request("/my-requests"),
    getRepresentationRequests: () => request("/representation/pending"),
    getPendingSales: () => request("/owner/pending-sales"),

    getBrokerProfile: () => request("/brokers/me/profile"),
    getManagedProperties: () => request("/brokers/managed-properties"),
    getMarketplaceProperties: () => request("/brokers/marketplace"),
    getCommissions: () => request("/brokers/commissions"),
    getBrokerLeads: () => request("/brokers/leads"),
    getLeadsFunnel: () => request("/analytics/leads-funnel"),
    getRepresentedDevelopments: () => request("/broker-units/my-developments"),

    getAdminStats: () => request("/admin/stats"),
    getAdminUsers: () => request("/admin/users"),

    getRequestResponses: (requestId) =>
      request(`/requests/${requestId}/responses`),
    updateRequestStatus: (requestId, status) =>
      request(`/my-requests/${requestId}/status?status=${status}`, {
        method: "PATCH",
      }),

    getSubscriptionStatus: (sessionId) =>
      request(`/subscription/status/${sessionId}`),

    createCheckoutSession: (payload) =>
      request("/subscription/checkout", {
        method: "POST",
        body: JSON.stringify(payload),
        json: true,
      }),

    restoreProperty: (propertyId) =>
      request(`/properties/${propertyId}/restore`, { method: "PATCH" }),
    restoreDevelopment: (developmentId) =>
      request(`/developments/${developmentId}/restore`, { method: "PATCH" }),
  };
};
